export const insecureSkipVerifyText = `Unsafe SSL controls whether a client verifies the server's certificate chain and host name. \n
If checked, TLS accepts any certificate presented by the server and any host name in that certificate.`
